import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import {
  creatCallFlows,
  getExistingUserLocations,
  getMisc,
} from "../../../apiclients/streamsapi_bridge";
import { MDBSpinner } from "mdb-react-ui-kit";
import { MDBBtn, MDBModalFooter } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

export default function AddCallFlow(props) {
  const { t, i18n } = useTranslation();
  const [autoext, setAutoext] = useState(true);
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [locations, setLocations] = useState([]);
  const nameInputRef = useRef();
  const [copyObj, setCopyObj] = useState(props.oncopy ? props.oncopy : {});

  // const [error, setError] = useState({});
  const thName = useRef();
  const { register, handleSubmit, getValues, setValue, setError, formState , clearErrors } =
    useForm({
      defaultValues: {
        name: copyObj.name ? copyObj.name + "Copy" : "",
        extension: "",
        loc_id: "",
      },
    });
  const { errors, isDirty } = formState;

  const navigate = useNavigate();

  const onsubmit = async (data) => {
    let updates = {};
    if (isDirty) {
      let updates = {};
      setCheckAvailbility(false);
      if (copyObj) {
        updates = {
          reqid: 52,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          name: data.name,
          extension: parseInt(data.extension),
          loc_id: parseInt(data.loc_id),
          copy_id: copyObj.call_flow_id,
        };
      } else {
        updates = {
          reqid: 52,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          name: data.name,
          extension: parseInt(data.extension),
          loc_id: parseInt(data.loc_id),
        };
      }

      console.log(data);
      console.log(updates);
      setIsloading(true);
      let saverep = await creatCallFlows(updates);
      setTimeout(() => {
        setIsloading(false);
      }, 2000);
      let saverepeMsg = await saverep.json();
      console.log("22222222222222222222222222222222222222222");
      console.log(saverepeMsg);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        localStorage.setItem(
          "s_message",
          "CallFlow " + data.name + " created successfully."
        );
        props.onClose();
        props.onSucess({ "name": data.name, "extension": data.extension, new: "1" });
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        } else {
          localStorage.setItem("f_message", saverepeMsg.message);
          props.onClose();
          window.location.href = "/callflowlanding";
        }
      }
    }
  };

  async function checkAvailability(e) {
    if (e.target.value.trim() == "") {
      return;
    }
    setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: e.target.value }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  async function getLocations() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));

    const response = await getExistingUserLocations(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const data = await response.json();
    if (!data) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + data);
    setLocations(data.locations);
  }
  useEffect(() => {
    getLocations();
  }, []);
  useEffect(() => {
    setTimeout(() => {
      if (nameInputRef.current) {
        nameInputRef.current.focus();
      }
    }, 1000);
  }, []);
  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div>
        <div className="tel-numbers">
          <strong>{t("callflow_name")} *</strong>
        </div>
        <form>
          <div className="form pt-1">
            <input
              type="text"
              ref={nameInputRef}
              maxLength={50}
              className="form-control"
              tabIndex={1}
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
          <div>
            <div className="pt-2">
              <div className="tel-numbers mt-2">
                <strong>{t("extension")} *</strong>
              </div>

              <input
                type="text"
                className="form-control w-100"
                maxLength={5}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register("extension", {
                  setValueAs: (value) => Number(value),
                  required: "Extension is required",
                  minLength: {
                    value: 3,
                    message: "Extension must be at least 3 characters",
                  },
                  maxLength: {
                    value: 5,
                    message: "Extension must not exceed 5 characters",
                  },
                })}
                onChange={(e) => {
                  e.preventDefault();
                  const value = e.target.value;
                  if (value.length >= 3 && value.length <= 5) {
                    checkAvailability(e); 
                  } else {
                    setCheckAvailbility(false); 
                    clearErrors("extension");
                  }
                }}
              />
              {errors.extension && (
                <>
                  {!checkAvailbility ? (
                    <p className="text-danger">{errors.extension.message}</p>
                  ) : (
                    <p style={{ color: "Green" }} className="clr-red">
                      {errors.extension.message}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="tel-numbers mt-2">
            <strong>{t("location")} *</strong>
          </div>

          <div className="phoneselect">
            <select
              className="form-control form-select selectname"
              name="San Jose"
              {...register("loc_id", { required: "Location is required" })}
            >
              <option value="-1">--- Select Location ---</option>
              {locations &&
                locations.map((item) => (
                  <>
                    <option value={item.location_id}>
                      {item.location_name}
                    </option>
                  </>
                ))}
            </select>
          </div>
          {errors.loc_id && (
            <p className="text-danger">{"Location is required"}</p>
          )}
          <br />
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={props.onClose}>
              {t("close")}
            </MDBBtn>
            <MDBBtn
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(onsubmit)();
              }}
            >
              {t("add")}
            </MDBBtn>
          </MDBModalFooter>
        </form>
      </div>
    </>
  );
}
